/*
 *
 * Courses actions
 *
 */

import {
  FLUSH_STATE,
  LOAD_COURSES,
  LOAD_COURSES_SUCCESS,
  LOAD_COURSES_ERROR,
  UPDATE_COURSE,
  UPDATE_COURSE_SUCCESS,
  UPDATE_COURSE_ERROR,
} from './constants';

export function flushState() {
  return {
    type: FLUSH_STATE,
  };
}

/**
 * Load the courses, this action starts the request saga
 *
 * @return {object} An action object with a type of LOAD_COURSES
 */
export function loadMobileCourses(options) {
  return {
    type: LOAD_COURSES,
    options
  };
}

/**
 * Dispatched when the loadCourses are loaded by the request saga
 *
 * @param  {array} variables true for courses
 *
 * @return {object}      An action object with a type of LOAD_COURSES_SUCCESS passing the variables
 */
export function loadCoursesSuccess(itemsList, appointments) {
  return {
    type: LOAD_COURSES_SUCCESS,
    itemsList,
    appointments
  };
}

/**
 * Dispatched when loading the loadCourses fails
 *
 * @param  {object} error The error
 *
 * @return {object}       An action object with a type of LOAD_COURSES_ERROR passing the error
 */
export function loadCoursesError(error) {
  return {
    type: LOAD_COURSES_ERROR,
    error,
  };
}

// Update for Single User
export function updateCourse(courseDetail) {
  return {
    type: UPDATE_COURSE,
    courseDetail,
  };
}
export function updateCourseSuccess(courseDetail) {
  return {
    type: UPDATE_COURSE_SUCCESS,
    courseDetail,
  };
}

export function updateCourseError(error) {
  return {
    type: UPDATE_COURSE_ERROR,
    error,
  };
}
